import type {
  ComponentPropsWithoutRef,
  ElementType,
  FunctionComponent,
} from 'react'
import React from 'react'

import classnames from 'classnames'

import { AnimationWrapper } from '../../AnimationWrapper'
import { Label } from '../../Label'
import { BaseLink } from '../../Links'
import { TypographyV2 } from '../../Seatbelt2/Foundations/Typography'
import styles from './ContentCard.module.scss'

export const ContentCard: FunctionComponent<Props> = ({
  className,
  href,
  icon: Icon,
  label,
  strapline,
  title,
  ...rest
}) => (
  <article
    data-testid="content-card"
    className={classnames(styles.card, className)}
    {...rest}
  >
    <BaseLink href={href} invertedUnderline={true}>
      <div className={styles.contentWrapper}>
        <div className={styles.contentPadding}>
          {Icon && <Icon className={styles.icon} />}
          {label && <Label className={styles.label} labelText={label} />}
        </div>
        <div className={styles.text}>
          <TypographyV2
            tag="h2"
            textStyle="sb-text-interface-heading-large"
            className={classnames(strapline && styles.header)}
          >
            <AnimationWrapper inverted={true}>{title}</AnimationWrapper>
          </TypographyV2>
          {strapline && (
            <TypographyV2
              className={styles.strapline}
              textStyle="sb-text-body-default-regular"
            >
              {strapline}
            </TypographyV2>
          )}
        </div>
      </div>
    </BaseLink>
  </article>
)

///////// IMPLEMENTATION /////////

export type Props = {
  /**
   * Optional class
   */
  className?: string
  /**
   * URL for destination of card
   */
  href: string
  /**
   * Icon
   */
  icon?: ElementType
  /**
   * Text for the label
   */
  label?: string
  /**
   * Strapline text
   */
  strapline?: string
  /**
   * Text for the title of the component
   */
  title: string
} & ComponentPropsWithoutRef<'article'>
